import type { UserType } from "@shared/types";
import { toast } from "sonner";
import i18n from "@/i18n";

/** One id, so a switch seen by two paths in the same tab shows one toast. */
export const ROLE_SWITCHED_ELSEWHERE_TOAST_ID = "role-switched-elsewhere";

/**
 * Tell a tab that followed a role switch it did not make why its screen
 * changed.
 */
export function showRoleSwitchedElsewhereNotice(role: UserType): void {
	toast.info(
		i18n.t("roleSession.switchedElsewhere", {
			role: i18n.t(`roleSession.roleNames.${role}`),
		}),
		{ id: ROLE_SWITCHED_ELSEWHERE_TOAST_ID },
	);
}
